import type { ExtendedDocumentReference } from '@seen/core/models/document-references/documentReferences'
import type { Folder } from '@seen/core/models/document-references/folder'
import { Button } from '@seen/ui'
import { IconUpload } from '@tabler/icons-react'
import { type JSX, useState } from 'react'
import { AddDocumentModal } from '#src/components/document-reference/AddDocumentModal.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

interface AddDocumentButtonProps {
  onSuccess?: (documentReference: ExtendedDocumentReference) => void
  initialFolder?: Folder
}

export function AddDocumentButton({
  onSuccess,
  initialFolder,
}: AddDocumentButtonProps): JSX.Element | null {
  const [modalOpen, setModalOpen] = useState(false)
  const isReadOnly = useIsReadOnly()

  if (isReadOnly) {
    return null
  }

  return (
    <>
      <Button
        variant="outline"
        className="flex items-center gap-2"
        onClick={() => setModalOpen(true)}
      >
        <IconUpload size={16} />
        Add Document
      </Button>
      <AddDocumentModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        onSuccess={onSuccess}
        initialFolder={initialFolder}
      />
    </>
  )
}
